import theme_ef from './ef/theme';
import theme_ms from './ms/theme';
import config from '../config'
const PLATFORM = config.REACT_APP_PLATFORM;

function getTheme(): any {
    switch (PLATFORM) {
        case 'ef':
            return theme_ef;
        case 'ms':
            return theme_ms;
        default:
            return theme_ef;
    }
}

export default getTheme();
